import { createTheme, responsiveFontSizes } from '@mui/material/styles';

export let theme = createTheme({
  palette: {
    primary: { main: 'rgb(254, 98, 98)' },
    secondary: { main: 'hsla(359, 58%, 58%, 1)' },
    background: { default: '#1a1a1d' },
    text: { primary: '#fff', secondary: '#8f8f8f' },
  },
  typography: {
    fontFamily: '"Inter", sans-serif',
    /*...font.style,*/ h1: { fontWeight: 800, fontFamily: 'Clash Display' },
    h2: { fontWeight: 800, fontFamily: 'Clash Display' },
    button: { fontWeight: 600 },
  },
});
theme = {
  ...theme,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 100,
          color: '#fff',
          '&.Mui-disabled': {
            color: '#8f8f8f',
            border: '1px solid #3c3c3f',
          },
        },
        outlined: {
          border: '1px solid #3c3c3f',
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          [theme.breakpoints.up('xs')]: {
            paddingLeft: 0,
            paddingRight: 0,
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#212023',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: '#1a1a1d',
          color: '#fff',
          border: '1px solid #3c3c3f',
        },
        input: {
          '&.Mui-disabled': {
            '-webkit-text-fill-color': '#8f8f8f',
          },
        },
        disabled: {
          color: '#8f8f8f',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#1a1a1d',
          '&.Mui-disabled': {
            color: '#8f8f8f',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          border: '1px solid #3c3c3f',
          color: '#ffffff',
          '&.Mui-disabled': {
            color: '#8f8f8f',
          },
        },
        select: {
          '&.Mui-disabled': {
            color: '#8f8f8f',
          },
        },
        nativeInput: {
          color: '#fff',
        },
        disabled: {
          color: '#8f8f8f',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: 'text.secondary',
          backgroundColor: '#1a1a1d',
          padding: '0 0.5rem',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'text.secondary',
          '&.Mui-disabled': {
            color: '#8f8f8f',
            backgroundColor: '#1a1a1d',
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          color: 'text.secondary',
        },
      },
    },
  },
};
theme = responsiveFontSizes(theme);
